import * as d3Dispatch from 'd3-dispatch';
import * as d3Path from 'd3-path';
import * as d3Scale from 'd3-scale';
import * as d3Selection from 'd3-selection';

const d3 = { ...d3Dispatch, ...d3Path, ...d3Scale, ...d3Selection };

export default d3;
